import jss from 'jss';

const styles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    height: '100%',
    '& > *': {
      flex: 0
    }
  },
  actionsContainer: {
    marginTop: 15,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  actionsInnerContainer: {
    '& > *': {
      marginRight: 5
    }
  },
  requiredIndicator: {
    fontSize: '.83em',
    verticalAlign: 'super',
    color: 'red'
  }
};

export const { classes } = jss.createStyleSheet(styles).attach();


// WEBPACK FOOTER //
// ./src/views/user/styles/modify.js